import {
	AcceptSalesOrderRequest,
	AddressDTO,
	AddressLocationDTO,
	CancelSalesOrderRequest,
	CancelSalesOrderResponse,
	ChangeSalesOrderDeliveryPersonRequest,
	CloseSalesOrderFromPosRequest,
	CloseSalesOrderFromPosResponse,
	DeliverTakeOutOrderRequest,
	DeliveryPersonDTO,
	DeliveryStatus,
	EndTakeOutOrderRequest,
	EndTakeOutOrderResponse,
	GetDeliveryPersonsRequest,
	GetDeliveryPersonsResponse,
	GetPendingSalesOrderByIdRequest,
	GetPendingSalesOrderByIdResponse,
	GetSalesOrderDeliveryAddressLocationRequest,
	GetSalesOrderDeliveryAddressLocationResponse,
	GetTakeOutOrdersByDeliveryDateRequest,
	GetTakeOutOrdersByDeliveryDateResponse,
	InvoiceParamsFromPosDTO,
	MarkOrderAsPreparedRequest,
	MarkSalesOrderAsDeliveredRequest,
	RejectSalesOrderRequest,
	SaleDTO,
	SalesOrderDTO,
	SalesOrderParamsFromTakeOutDTO,
	SalesOrderType,
	SearchTakeOutOrderRequest,
	SearchTakeOutOrderResponse,
	SearchTakeOutOrderResultDTO,
	UpdateSalesOrderDeliveryAddressRequest
} from 'core/api';

import { Bus, SessionProvider } from 'core/infrastructure';

const process = Bus.buildProcessFn('/bus/');

export async function getByDeliveryDate(deliveryDateTime: Date, types: (SalesOrderType.Delivery | SalesOrderType.TakeAway)[], statuses: DeliveryStatus[]): Promise<SalesOrderDTO[]> {
	const deliveryDate = new Date(deliveryDateTime.setHours(0, 0, 0, 0));
	const request = new GetTakeOutOrdersByDeliveryDateRequest({ deliveryDate, types, statuses });
	return process(request, (response: GetTakeOutOrdersByDeliveryDateResponse) => response.SalesOrders);
}

export async function accept(salesOrderId: number): Promise<void> {
	const request = new AcceptSalesOrderRequest({ salesOrderId });
	await process(request);
}

export async function reject(salesOrderId: number): Promise<void> {
	const request = new RejectSalesOrderRequest({ salesOrderId });
	await process(request);
}

export async function markAsPrepared(orderId: number): Promise<void> {
	const request = new MarkOrderAsPreparedRequest({ salesOrderId: orderId });
	await process(request);
}

export async function deliver(salesOrderId: number): Promise<void> {
	const request = new DeliverTakeOutOrderRequest({ salesOrderId });
	await process(request);
}


export async function changeDeliveryPerson(orderId: number, deliveryPersonId: number): Promise<void> {
	const request = new ChangeSalesOrderDeliveryPersonRequest({ orderId, deliveryPersonId });
	await process(request);
}

export async function getDeliveryPersonStatuses(): Promise<DeliveryPersonDTO[]> {
	const request = new GetDeliveryPersonsRequest();
	return await process(request, (response: GetDeliveryPersonsResponse) => response.Statuses);
}

export async function markAsDelivered(salesOrderId: number): Promise<void> {
	const request = new MarkSalesOrderAsDeliveredRequest({ salesOrderId });
	await process(request);
}

export async function cancel(orderId: number): Promise<{ success: boolean, errorMessage: string }> {
	const request = new CancelSalesOrderRequest({ orderId, overridePosId: null, overrideBusinessDay: null, overrideCreationDate: null, audit: true });
	return await process(request, (response: CancelSalesOrderResponse) => ({ success: response.Success, errorMessage: response.ErrorMessage }));
}

export async function close(orderId: number, params: InvoiceParamsFromPosDTO): Promise<SaleDTO> {
	const request = new CloseSalesOrderFromPosRequest({ orderId, params });
	return process(request, (response: CloseSalesOrderFromPosResponse) => response.Sale);
}

export async function end(ticketId: number, params: SalesOrderParamsFromTakeOutDTO): Promise<SaleDTO> {
	const request = new EndTakeOutOrderRequest({ ticketId, params });
	return process(request, (response: EndTakeOutOrderResponse) => response.Sale);
}

export async function searchOrder(serie: string, orderNumber: number): Promise<SearchTakeOutOrderResultDTO> {
	const request = new SearchTakeOutOrderRequest({ serie, number: orderNumber });
	return process(request, (response: SearchTakeOutOrderResponse) => response.Result);
}

export async function getDeliveryLocation(orderId: number): Promise<{ deliveryAddress: AddressDTO; location: AddressLocationDTO; }> {
	const request = new GetSalesOrderDeliveryAddressLocationRequest({ orderId });
	return process(request, (response: GetSalesOrderDeliveryAddressLocationResponse) => ({ deliveryAddress: response.DeliveryAddress, location: response.Location }));
}
export async function updateDeliveryAddress(orderId: number, updatedDeliveryAddress: AddressDTO, location: AddressLocationDTO): Promise<void> {
	const request = new UpdateSalesOrderDeliveryAddressRequest({ orderId, updatedDeliveryAddress, location });
	await process(request);
}

export async function getById(orderId: number): Promise<SalesOrderDTO> {
	const request = new GetPendingSalesOrderByIdRequest({ orderId, isTrainingMode: SessionProvider.getCurrent().IsTrainingMode });
	return process(request, (response: GetPendingSalesOrderByIdResponse) => response.Order);
}

